import React, { memo, useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { IaCreators } from "../../../store/actions/intelligence";
import { BotsCreators } from "../../../store/actions/bots";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import "./style.scss";

import Card from "./components/Card";
import CardsAprimoramento from './components/CardsAprimoramento/CardsAprimoramento'
import FilterAprimoramento from './components/FilterAprimoramento/FilterAprimoramento'

import { toastr } from "react-redux-toastr";

function Aprimoramento(props) {

  const [selectedMessage, setSelectedMessage] = useState("");

  useEffect(() => {
    return () => {
      setSelectedMessage(null)
    }
  }, []);

  return (
    <div className="enhancement">
      {selectedMessage && (
        <div>
          <div className="info-edit-enhancement">
            <p>Você está aprimorando a IA definindo as intenções de resposta do seu usuário.</p>
            <p>
              Basta selecionar o trecho do texto e atribuir a ele a característica de{" "}
              <span className="opt-type-tag" style={{ backgroundColor: "#00B799" }}>
                intenção
              </span>{" "}
              ou{" "}
              <span className="opt-type-tag" style={{ backgroundColor: "#FF770D" }}>
                entidade
              </span>
              .
            </p>
          </div>
          <div>
            <Card
              message={selectedMessage}
              selectedMessage={selectedMessage}
              setSelectedMessage={setSelectedMessage}
            />
            <CardsAprimoramento />
          </div>
        </div>
      )}
      {!selectedMessage && (
        <div>
          <FilterAprimoramento />

          {props.curation?.messages?.length > 0 ? 
            props.curation?.messages?.map((message) => (
              <Card
                key={'card-curation' + message._id}
                message={message}
                selectedMessage={null}
                setSelectedMessage={setSelectedMessage}
              />
            )) : (
              <div className="info-warning-enhancement">
                <p>Não existem mensagens a serem listadas</p>
              </div>
            )
          }
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  bot: state.bots.bot,
  curation: state.intelligence.curation,
  aprimoramentos: state.intelligence.aprimoramentos
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...IaCreators,
      ...BotsCreators,
    },
    dispatch
  );

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(memo(Aprimoramento))));
